import styled from "styled-components";

export const StyledAdvancedSearch = styled.div`
	padding: 0.8rem 1.6rem;
	display: flex;
	align-content: center;
`;
